import React from 'react';

function openInTelegram(url) {
  if (window.Telegram?.WebApp?.openTelegramLink) {
    window.Telegram.WebApp.openTelegramLink(url);
  } else {
    window.location.href = url;
  }
}

export default function WebGate() {
  const deeplink = 'https://t.me/hotbump_bot?startapp=start';

  return (
    <div style={{ position: 'fixed', inset: 0 }}>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url(/assets/bg-girl.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(0,0,0,0.55)',
          backdropFilter: 'blur(2px)'
        }}
      />
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: 24,
          color: '#fff'
        }}
      >
        <div style={{ maxWidth: 560 }}>
          <h1 style={{ marginBottom: 12 }}>Работает только в официальном приложении Telegram</h1>
          <p style={{ opacity: 0.9, marginBottom: 20 }}>
            Откройте мини‑приложение из Telegram, чтобы продолжить.
          </p>
          <button
            onClick={() => openInTelegram(deeplink)}
            style={{
              display: 'inline-block',
              padding: '12px 18px',
              background: '#27A7E7',
              color: '#fff',
              borderRadius: 10,
              border: 'none',
              fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            Открыть в Telegram
          </button>
          <div style={{ marginTop: 10, fontSize: 12, opacity: 0.8 }}>18+</div>
        </div>
      </div>
    </div>
  );
}




